import React from "react"
import {Container} from "@material-ui/core"

// Components
import SignInForm from "../SignInForm"

export default () => (
    <Container maxWidth="xs">
        <SignInForm/>
    </Container>
)
